import React, { useState } from "react";
import { Typography, IconButton } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import Table from "../../../../components/tables/Table";
import styles from "../../../../components/tables/Table.styles";
import { useNavigate } from "react-router-dom";
import { useNavWithTrail } from "../../../../layouts/TrailProvider";
import UnitActionsDialog from "../Edit/UnitActionsDialog";

export default function UnitTable({ rows = [], actionsEnabled = true }) {
  const navigate = useNavigate();
  const nav = useNavWithTrail(navigate);

  const [selectedRow, setSelectedRow] = useState(null);
  const [actionsOpen, setActionsOpen] = useState(false);

  const columns = [
    {
      field: "name",
      label: "Name",
      sortable: true,
      type: "string",
      render: (_row, value) => (
        <Typography
          sx={styles.tableLink}
          onClick={() => nav(`/home/units/${encodeURIComponent(value)}`)}
        >
          {value}
        </Typography>
      ),
    },
    {
      field: "effectiveFrom",
      label: "Effective From",
      sortable: true,
      type: "date",
      accessor: (row) => row.effectiveFrom?.iso,
      render: (row) => row.effectiveFrom?.display || '',
    },
    { field: "operator", label: "Operator", sortable: true, type: "string" },
    { field: "stoodDown", label: "Stood Down", sortable: true, type: "boolean" },
    { field: "excluded", label: "Excluded", sortable: true, type: "boolean" },
  ];

  const actionsRenderer = actionsEnabled
    ? (row) => (
        <div style={{ display: "flex", gap: 8 }}>
          <IconButton
            aria-label={`Edit Unit ${row.name}`}
            size="small"
            sx={styles.compactActionButton}
            onClick={() => {
              setSelectedRow(row);
              setActionsOpen(true);
            }}
          >
            <EditIcon sx={styles.editIcon} />
          </IconButton>
        </div>
      )
    : null;

  return (
    <>
      <Table
        rows={rows}
        columns={columns}
        actionsRenderer={actionsRenderer}
        actionsHeader={actionsEnabled ? "Actions" : null}
        stickyHeader
        zebra
        hover
        bordered

      />

      {actionsOpen && selectedRow && (
        <UnitActionsDialog
          open
          initialData={{
            name: selectedRow.name,
            effectiveFrom: selectedRow.effectiveFrom,
            operator: selectedRow.operator,
            stoodDown: !!selectedRow.stoodDown,
          }}
          onClose={() => {
            setActionsOpen(false);
            setSelectedRow(null);
          }}
          onSubmit={() => {
            setActionsOpen(false);
            setSelectedRow(null);
          }}
          defaultTabKey="modify"
        />
      )}
    </>
  );
}
